"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _OpenGraphMeta = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/OpenGraphMeta"));

var _RobotsMeta = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/RobotsMeta"));

var _TwitterMeta = _interopRequireDefault(require("ecosystem-marketplace-core/components/elements/TwitterMeta"));

var _DocumentHead = _interopRequireDefault(require("ecosystem-marketplace-core/components/portals/DocumentHead"));

var _PrerenderReady = _interopRequireDefault(require("ecosystem-marketplace-core/components/prerender/PrerenderReady"));

var _RequestState = require("ecosystem-marketplace-core/constants/RequestState");

var Category = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Category"));

var SuperCategory = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/SuperCategory"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var ecosystemClient = _interopRequireWildcard(require("../../clients/ecosystemClient"));

var _constants = require("../../constants");

var StorefrontCollection = _interopRequireWildcard(require("../../constants/StorefrontCollection"));

var FilterKey = _interopRequireWildcard(require("../../constants/search/FilterKey"));

var SortField = _interopRequireWildcard(require("../../constants/search/SortField"));

var _SearchResult = _interopRequireDefault(require("../../records/SearchResult"));

var _StorefrontFilters = _interopRequireDefault(require("../../records/StorefrontFilters"));

var _auth = require("../../selectors/auth");

var _earlyRequests = require("../../utils/earlyRequests");

var _history = require("../../utils/history");

var _useParsedPathParams2 = require("../../utils/hooks/useParsedPathParams");

var _usePrevious = require("../../utils/hooks/usePrevious");

var _i18n2 = require("../../utils/i18n");

var _requestState = require("../../utils/requestState");

var _strings = require("../../utils/strings");

var _urls = require("../../utils/urls");

var _StorefrontFiltersContext = _interopRequireDefault(require("../../context/StorefrontFiltersContext"));

var _StorefrontUsageTrackerContext = _interopRequireDefault(require("../../context/StorefrontUsageTrackerContext"));

var _CanonicalLink = _interopRequireDefault(require("../../components/elements/CanonicalLink"));

var _GenericError = _interopRequireDefault(require("../../components/error/GenericError"));

var _ResultsPage = _interopRequireDefault(require("../../components/storefront/results/ResultsPage"));

var EMPTY_SEARCH_RESULT = new _SearchResult.default();
var EMPTY_ORDERED_SET = new _immutable.default.OrderedSet();

var SUPPLEMENTAL_COLLECTION_FILTERS = _immutable.default.OrderedSet([StorefrontCollection.POPULAR, StorefrontCollection.NEW, StorefrontCollection.FREE]).map(function (collection) {
  return new _StorefrontFilters.default((0, _defineProperty2.default)({}, FilterKey.COLLECTION, collection));
});

var FailedComponent = function FailedComponent() {
  return _react.default.createElement(_NavMarker.default, {
    name: "STOREFRONT_ERROR_LOAD"
  }, _react.default.createElement(_GenericError.default, null));
};

var SearchResults = function SearchResults(_ref2) {
  var history = _ref2.history,
      _ref2$match = _ref2.match,
      params = _ref2$match.params,
      url = _ref2$match.url;
  var activeCollectionSlug = params.collection,
      activeSuperCategorySlug = params.superCategory;

  var _useParsedPathParams = (0, _useParsedPathParams2.useParsedPathParams)(params),
      _useParsedPathParams$ = _useParsedPathParams.page,
      activePage = _useParsedPathParams$ === void 0 ? 1 : _useParsedPathParams$;

  var _useContext = (0, _react.useContext)(_StorefrontUsageTrackerContext.default),
      trackInteraction = _useContext.trackInteraction,
      trackPageView = _useContext.trackPageView,
      trackFilterView = _useContext.trackFilterView,
      trackResultClick = _useContext.trackResultClick;

  var _useContext2 = (0, _react.useContext)(_StorefrontFiltersContext.default),
      filters = _useContext2.filters,
      clearFilters = _useContext2.clearFilters,
      isAllCategories = _useContext2.isAllCategories,
      pushFilters = _useContext2.pushFilters,
      updateFilter = _useContext2.updateFilter;

  var _useState = (0, _react.useState)(EMPTY_SEARCH_RESULT),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      searchResult = _useState2[0],
      setSearchResult = _useState2[1];

  var totalResults = searchResult.total;

  var _useState3 = (0, _react.useState)(EMPTY_ORDERED_SET),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      supplementalResults = _useState4[0],
      setSupplementalResults = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      shouldTrackPageView = _useState6[0],
      setShouldTrackPageView = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      shouldTrackFilterView = _useState8[0],
      setShouldTrackFilterView = _useState8[1];

  var _useState9 = (0, _react.useState)(_RequestState.UNINITIALIZED),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      requestState = _useState10[0],
      setRequestState = _useState10[1];

  var requestFulfilled = (0, _requestState.isFulfilled)(requestState);
  var requestSucceeded = (0, _requestState.isSucceeded)(requestState);
  var activeCollection = filters[FilterKey.COLLECTION],
      activeSuperCategory = filters[FilterKey.SUPER_CATEGORY],
      activeCategory = filters[FilterKey.CATEGORY],
      planTypeValue = filters[FilterKey.PRICING],
      searchValue = filters[FilterKey.SEARCH];
  var limit = activeCollection === StorefrontCollection.NEW ? _constants.NEW_COLLECTION_SEARCH_LENGTH : _constants.DEFAULT_SEARCH_LENGTH;

  var _useState11 = (0, _react.useState)(0),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      pageCount = _useState12[0],
      setPageCount = _useState12[1];

  var offset = (activePage - 1) * limit;
  var prevFilters = (0, _usePrevious.usePrevious)(filters);
  var prevSearchValue = (0, _usePrevious.usePrevious)(searchValue);
  var prevUrl = (0, _usePrevious.usePrevious)(url);
  var handlePageChange = (0, _react.useCallback)(function (page, _filters) {
    var updatedFilters = _filters || filters;

    var _updatedFilters$toLoc = updatedFilters.toLocation(),
        newPathname = _updatedFilters$toLoc.pathname,
        restLocation = (0, _objectWithoutProperties2.default)(_updatedFilters$toLoc, ["pathname"]);

    history.push((0, _extends2.default)({}, restLocation, {
      pathname: (0, _urls.getPathPagination)(newPathname, page)
    }));
    window.scrollTo(0, 0);
  }, [filters, history]);
  var handleSortChange = (0, _react.useCallback)(function (field, order) {
    var updatedFilters = filters.withMutations(function (mutableFilters) {
      mutableFilters.set(FilterKey.SORT_FIELD, field).set(FilterKey.SORT_ORDER, order);
    });
    pushFilters(updatedFilters);
  }, [filters, pushFilters]);
  var renderedResults = (0, _react.useMemo)(function () {
    return _react.default.createElement(_ResultsPage.default, {
      activePage: activePage,
      failedComponent: FailedComponent,
      filters: filters,
      offset: offset,
      onClearFilters: clearFilters,
      onFilterChange: updateFilter,
      onPageChange: handlePageChange,
      onResultClick: function onResultClick(result, index, count) {
        return trackResultClick(result, index, {
          totalResults: count
        });
      },
      onSortChange: handleSortChange,
      requestState: requestState,
      resultProps: {
        collection: activeCollection,
        showCommitmentPrice: !planTypeValue
      },
      searchResult: searchResult,
      supplementalResults: supplementalResults,
      trackInteraction: trackInteraction
    });
  }, [activeCollection, activePage, clearFilters, filters, handlePageChange, handleSortChange, offset, planTypeValue, requestState, searchResult, supplementalResults, trackInteraction, trackResultClick, updateFilter]);
  var renderedPageMeta = (0, _react.useMemo)(function () {
    var count = totalResults || '';
    var hasNextPage = false;
    var hasPrevPage = false;
    var noIndexFollow = false;
    var metaDescription;
    var statusCode;
    var canonicalUrl = url;

    if (activeCategory === Category.CMS) {
      canonicalUrl = (0, _urls.getCollectionUrl)(StorefrontCollection.CMS);
    } else if (activeCollection === StorefrontCollection.ABM) {
      canonicalUrl = (0, _urls.getCategoryFilterUrl)(Category.ABM, SuperCategory.MARKETING);
    }

    if (requestSucceeded) {
      hasNextPage = activePage < pageCount;
      hasPrevPage = activePage > 1;

      if (searchValue) {
        noIndexFollow = true;
      } else if (!totalResults) {
        noIndexFollow = true;
        statusCode = 404;
      } else if (totalResults < 3) {
        noIndexFollow = true;
      }
    }

    if (activeCollection) {
      metaDescription = (0, _unescapedText.default)((0, _i18n2.getCollectionI18nKey)(activeCollection, 'metaDescription'), {
        count: count
      });
    } else if (activeCategory) {
      metaDescription = (0, _unescapedText.default)('appMarketplace.storefront.filters.category.metaDescription', {
        category: (0, _unescapedText.default)((0, _i18n.getCategoryI18nKey)(activeCategory)).toLocaleLowerCase()
      });
    } else {
      metaDescription = (0, _unescapedText.default)("appMarketplace.storefront.filters.category.items." + function () {
        switch (activeSuperCategory) {
          case SuperCategory.MARKETING:
            return 'marketing';

          case SuperCategory.SALES:
            return 'sales';

          case SuperCategory.CUSTOMER_SUCCESS:
            return 'customerSuccess';

          case SuperCategory.FINANCE:
            return 'finance';

          case SuperCategory.PRODUCTIVITY:
            return 'productivity';

          default:
            return 'all';
        }
      }() + ".metaDescription");
    }

    return _react.default.createElement(_auth.PublicOnly, null, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_CanonicalLink.default, {
      to: canonicalUrl
    }), hasPrevPage && _react.default.createElement(_CanonicalLink.default, {
      rel: "prev",
      to: (0, _urls.getPathPagination)(url, activePage - 1)
    }), hasNextPage && _react.default.createElement(_CanonicalLink.default, {
      rel: "next",
      to: (0, _urls.getPathPagination)(url, activePage + 1)
    }), _react.default.createElement("meta", {
      name: "description",
      content: metaDescription
    }), noIndexFollow && _react.default.createElement(_RobotsMeta.default, {
      noFollow: true,
      noIndex: true
    }), _react.default.createElement(_TwitterMeta.default, {
      name: "card"
    }), _react.default.createElement(_TwitterMeta.default, {
      name: "site"
    }), _react.default.createElement(_TwitterMeta.default, {
      name: "image",
      content: (0, _urls.getStorefrontScreenshotUrl)()
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "type"
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "title"
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "url",
      content: (0, _history.getFullHref)(url)
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "description",
      content: metaDescription
    }), _react.default.createElement(_OpenGraphMeta.default, {
      property: "image",
      content: (0, _urls.getStorefrontScreenshotUrl)()
    }), _react.default.createElement(_PrerenderReady.default, {
      ready: requestFulfilled,
      statusCode: statusCode
    })));
  }, [activeCategory, activeCollection, activePage, activeSuperCategory, pageCount, requestFulfilled, requestSucceeded, searchValue, totalResults, url]);
  (0, _react.useEffect)(function () {
    var count = totalResults || '';
    var documentTitle;

    if (activeCollection) {
      documentTitle = _I18n.default.text((0, _i18n2.getCollectionI18nKey)(activeCollection, 'htmlTitle'), {
        count: count
      });
    } else if (activeCategory || activeSuperCategory) {
      documentTitle = _I18n.default.text('appMarketplace.storefront.filters.category.htmlTitle', {
        count: count,
        category: (0, _strings.titlecase)((0, _unescapedText.default)(activeCategory ? (0, _i18n.getCategoryI18nKey)(activeCategory) : (0, _i18n.getSuperCategoryI18nKey)(activeSuperCategory)))
      });
    } else {
      documentTitle = _I18n.default.text('appMarketplace.storefront.filters.category.items.all.htmlTitle', {
        count: count
      });
    }

    document.title = documentTitle;
  }, [activeCategory, activeCollection, activeSuperCategory, totalResults]);
  (0, _react.useEffect)(function () {
    if (requestFulfilled && (shouldTrackPageView || shouldTrackFilterView)) {
      var properties = {
        pageNumber: activePage,
        totalResults: totalResults
      };

      if (shouldTrackPageView) {
        trackPageView(properties);
        setShouldTrackPageView(false);
      } else {
        trackFilterView(properties);
        setShouldTrackFilterView(false);
      }

      if (requestSucceeded && !totalResults) {
        trackInteraction('no results returned');
      }
    }
  }, [activePage, requestFulfilled, requestSucceeded, shouldTrackFilterView, shouldTrackPageView, totalResults, trackFilterView, trackInteraction, trackPageView]);
  (0, _react.useEffect)(function () {
    if (url !== prevUrl || searchValue && searchValue !== prevSearchValue) {
      setShouldTrackPageView(true);
      setSearchResult(EMPTY_SEARCH_RESULT);
    }
  }, [prevSearchValue, prevUrl, searchValue, url]);
  (0, _react.useEffect)(function () {
    if (url === prevUrl && searchValue === prevSearchValue && !filters.equals(prevFilters)) {
      setShouldTrackFilterView(true);
    }
  }, [filters, prevFilters, prevSearchValue, prevUrl, searchValue, url]); // TODO refactor

  (0, _react.useEffect)(function () {
    var query = filters.toSearchQuery({
      length: limit,
      offset: offset
    });
    var request;

    if (searchValue) {
      var allCategoriesFilters = filters.toAllCategories();

      var supplementalFilterQueryMap = _immutable.default.OrderedMap().withMutations(function (mutableMap) {
        if (activeCategory || activeSuperCategory) {
          mutableMap.set(allCategoriesFilters, allCategoriesFilters.toSearchQuery({
            length: limit,
            nextSearchMaxTrigger: 1
          }));
          var supplementalCategoryFilter = filters.withMutations(function (mutableFilters) {
            return mutableFilters.delete(FilterKey.CATEGORY_FEATURES).delete(FilterKey.SEARCH).set(FilterKey.SORT_FIELD, SortField.RANDOM);
          });
          mutableMap.set(supplementalCategoryFilter, supplementalCategoryFilter.toSearchQuery({
            length: 3
          }));
        }

        SUPPLEMENTAL_COLLECTION_FILTERS.map(function (collectionFilter) {
          return mutableMap.set(collectionFilter, collectionFilter.toSearchQuery({
            length: 3
          }));
        });
      });

      var primaryQuery = (0, _extends2.default)({}, query, {
        nextSearchMaxTrigger: 1
      });
      var supplementalQueries = supplementalFilterQueryMap.valueSeq().toArray();
      request = ecosystemClient.searchMulti([primaryQuery].concat((0, _toConsumableArray2.default)(supplementalQueries))).then(function (_ref3) {
        var _ref4 = (0, _toArray2.default)(_ref3),
            primary = _ref4[0],
            supplementals = _ref4.slice(1);

        return [primary].concat((0, _toConsumableArray2.default)(supplementalFilterQueryMap.mapEntries(function (_ref5, index) {
          var _ref6 = (0, _slicedToArray2.default)(_ref5, 1),
              supplementalFilters = _ref6[0];

          var supplementalResult = supplementals[index] || {};
          return [supplementalFilters, new _SearchResult.default((0, _extends2.default)({}, supplementalResult, {
            filters: supplementalFilters
          }))];
        }).valueSeq().toArray()));
      });
    } else {
      var earlyRequestName; // TODO potentially support quick fetch for categories

      if (activeCollectionSlug) {
        earlyRequestName = activeCollectionSlug + "-collection";
      } else if (activeSuperCategorySlug) {
        earlyRequestName = activeSuperCategorySlug + "-super-category";
      }

      request = (0, _earlyRequests.maybeEarlyRequest)(earlyRequestName, function () {
        var includePieSyncConnectors = true;

        if (isAllCategories) {
          includePieSyncConnectors = false;
        } else if (activeCollection === StorefrontCollection.FOR_AGENCIES || activeCollection === StorefrontCollection.NEW) {
          includePieSyncConnectors = false;
        }

        return ecosystemClient.search((0, _extends2.default)({}, query, {
          includePieSyncConnectors: includePieSyncConnectors
        }));
      }).then(function (result) {
        return [result];
      });
    }

    setRequestState(_RequestState.PENDING);
    request.then(function (_ref7) {
      var _ref8 = (0, _toArray2.default)(_ref7),
          result = _ref8[0],
          supplementals = _ref8.slice(1);

      var newSearchResult = new _SearchResult.default(result);
      setSearchResult(newSearchResult);
      setSupplementalResults(_immutable.default.OrderedSet(supplementals));
      setPageCount(Math.ceil(newSearchResult.total / limit));
      setRequestState(_RequestState.SUCCEEDED);
    }).catch(function (error) {
      console.error(error);
      setSearchResult(EMPTY_SEARCH_RESULT);
      setSupplementalResults(EMPTY_ORDERED_SET);
      setPageCount(0);
      setRequestState(_RequestState.FAILED);
    });
  }, [activeCategory, activeCollection, activeCollectionSlug, activeSuperCategory, activeSuperCategorySlug, filters, isAllCategories, limit, offset, searchValue]);
  return _react.default.createElement(_NavMarker.default, {
    active: requestSucceeded,
    name: "STOREFRONT_LOAD"
  }, renderedResults, renderedPageMeta);
};

SearchResults.propTypes = {
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    replace: _propTypes.default.func.isRequired
  }),
  match: _propTypes.default.shape({
    params: _propTypes.default.object.isRequired,
    url: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = SearchResults;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/containers/storefront/SearchResults.js
// module id = 898
// module chunks = 209 210 211 212